var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 8.33325V8.49992C8.87983 8.71009 9.33524 9.10542 9.62013 9.61699C9.90501 10.1285 10.0013 10.7239 9.89219 11.2992C9.78309 11.8744 9.47551 12.3932 9.02311 12.7649C8.5707 13.1366 8.00217 13.3378 7.41664 13.3333H4.16664C3.58812 13.3189 3.0325 13.1042 2.59457 12.7259C2.15663 12.3476 1.8635 11.8291 1.76518 11.2588C1.66685 10.6885 1.76942 10.1018 2.05538 9.59865C2.34135 9.09554 2.79301 8.70721 3.33331 8.49992V8.33325C3.33331 7.67021 3.5967 7.03433 4.06554 6.56549C4.53439 6.09664 5.17027 5.83325 5.83331 5.83325C6.49635 5.83325 7.13224 6.09664 7.60108 6.56549C8.06992 7.03433 8.33331 7.67021 8.33331 8.33325Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 13.3333V18.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15.8333V18.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8333H16.9167C17.0798 15.831 17.2386 15.7809 17.3735 15.6892C17.5084 15.5975 17.6134 15.4682 17.6755 15.3174C17.7377 15.1665 17.7541 15.0008 17.7229 14.8407C17.6917 14.6806 17.6142 14.5331 17.5 14.4167L15 11.6667H15.25C15.4131 11.6644 15.572 11.6143 15.7069 11.5225C15.8418 11.4308 15.9468 11.3015 16.0089 11.1507C16.071 10.9999 16.0875 10.8341 16.0563 10.674C16.0251 10.5139 15.9476 10.3665 15.8334 10.25L13.3334 7.5H13.5C13.6702 7.51535 13.841 7.478 13.9893 7.39301C14.1376 7.30802 14.2561 7.1795 14.3289 7.02487C14.4017 6.87023 14.4251 6.69696 14.3961 6.52854C14.3671 6.36013 14.287 6.2047 14.1667 6.08333L10.8334 2.5L9.66669 3.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees);
export default __webpack_public_path__ + "static/media/trees.d55f23a21bd10e05730046850ffa6e5a.svg";
export { ForwardRef as ReactComponent };